import React from 'react';
import { ArrowRight } from 'lucide-react';
export function BeforeAfterGallery() {
  const images = [{
    image: 'https://cdn.magicpatterns.com/uploads/3mV4WLSKvQx371KiD3Q7Mc/a1.png',
    alt: 'Modern walk-in shower with marble walls and glass door'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/hYiix3WXGT9Kozhjym7PHc/b2.jpg',
    alt: 'Elegant double vanity bathroom with blue cabinets'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/h47fz1GtRRo8JjrK8zSG9o/c3.png',
    alt: 'Accessible shower with teak bench and grab bars'
  }];
  return <div className="space-y-8" data-id="element-27">
      {/* Eyebrow + Headline */}
      <div className="text-center mb-8" data-id="element-28">
        <p className="text-sm font-medium text-[#8BA888] mb-3" data-id="element-29">
          Our Recent Projects
        </p>
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3" data-id="element-30">
          You Know You Deserve This
        </h2>
        <p className="text-gray-600" data-id="element-31">
          Quality craftsmanship that transforms your bathroom into a space
          you'll love.
        </p>
      </div>

      {/* Image Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-32">
        {images.map((item, index) => <div key={index} className="relative group" data-id="element-33">
            <div className="relative overflow-hidden rounded-lg shadow-lg aspect-[4/3]" data-id="element-34">
              <img src={item.image} alt={item.alt} className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" data-id="element-35" />
            </div>
          </div>)}
      </div>

      {/* CTA Button */}
      <div className="text-center mt-8" data-id="element-36">
        <a href="https://www.facebook.com/luckyduckbath/photos" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border-2 border-[#8BA888] text-[#8BA888] hover:bg-[#8BA888]/10 transition-colors font-medium" data-id="element-37">
          See Our Work Here
          <ArrowRight className="h-4 w-4" data-id="element-38" />
        </a>
      </div>
    </div>;
}